import { Typography } from '@snowball-tech/fractal/dist/src/components/Typography'
import { cn } from '@snowball-tech/fractal/dist/src/styles/helpers'

import isEmpty from 'lodash/fp/isEmpty'

/** @public */
export enum LabelPositions {
  Center = 'center',
  End = 'end',
  Start = 'start',
}
type Props = {
  className?: string
  label?: string
  labelClassName?: string
  labelPosition?: LabelPositions
}
export default function Separator({
  className = '',
  label,
  labelClassName = '',
  labelPosition = LabelPositions.Center,
}: Props) {
  const separator = (
    <hr
      className={cn(
        'h-px max-h-px min-h-px min-w-1 w-full bg-separator',
        className,
      )}
    />
  )

  return isEmpty(label) ? (
    separator
  ) : (
    <div className="flex items-center gap-1 w-full">
      {(labelPosition === LabelPositions.Center ||
        labelPosition === LabelPositions.End) &&
        separator}

      <Typography
        className={cn(
          'flex-1 w-full min-w-fit whitespace-nowrap',
          labelClassName,
        )}
        variant="caption-median"
      >
        {label}
      </Typography>

      {(labelPosition === LabelPositions.Center ||
        labelPosition === LabelPositions.Start) &&
        separator}
    </div>
  )
}
